//MULTISELECT SCRIPT START
$(document).ready(function () {
    $('.multiselect-control,.form-select[multiple="multiple"]').multiselect({
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        enableFullValueFiltering: false,
        includeSelectAllOption: true,
        maxHeight: 345,
        buttonWidth: '100%',
    });

    setTimeout(function () {
        var fieldEle = $(".node-knowledge-form .form-item-field-country,.node-knowledge-form .form-item-field-resource-city")
        fieldEle.find(".multiselect-container .multiselect-all").next('li').hide().find('input[type="checkbox"]').trigger('click');
        $('.filter-dropdown-container').find('.form-actions .form-submit').first().addClass('btn-lg');
        $('.filter-dropdown-container').find('.form-actions .form-submit').last().addClass('btn-lg btn-border-custom');
    }, 500);
});
//MULTISELECT SCRIPT END


